import { fileCertificate } from "@simplybusiness/icons";
import { Box, Flex, Icon, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { CoverageProps } from ".";
import { IncludedByInsurerCoverage } from "./IncludedByInsurerCoverage";
import { transformCoverage } from "./transformCoverage";
import { UpsellContent } from "../Upsells/UpsellContent";
import { DisplayCover } from "./DisplayCover";

// Use transformation logic to display a list of covered and
// deductible items for each applicable quote.
export const Coverage = ({
  helpText = [],
  covers,
  extraCovers,
  className,
  displayVariant,
  withModal,
  additionalCoverage,
  upsells = [],
}: CoverageProps) => {
  const transformedCovers = transformCoverage(covers);
  const hasOtherStatesCoverage =
    displayVariant !== "qcp" &&
    transformedCovers.some(
      cover => cover.displayName === "Other States Coverage",
    );
  const hasAccidentPolicyCoverage = covers.some(
    cover => cover.displayName === "24/7 Medical Expense",
  );
  const displayCovers = transformedCovers.filter(
    cover => cover.displayName !== "Other States Coverage",
  );

  const coverageTitle = "Coverage Information";
  const coverageContainerStyles = classNames(
    "mobius-quote-card__coverage",
    className,
  );

  return (
    <Box className={coverageContainerStyles}>
      <Text className="mobius-quote-card__coverage-title" variant="h3">
        <Icon
          data-testid="coverage-title-icon"
          icon={fileCertificate}
          title="Coverage information document"
        />
        &nbsp;
        {coverageTitle}
      </Text>
      <Flex
        flexDirection="column"
        gap="sm"
        className="mobius-quote-card__coverage-items"
      >
        {displayCovers.map(
          ({
            displayName,
            coverName,
            quoteDetailsDisplayLimits: limits,
            quoteCardExcesses,
            quoteSliderExcesses,
            excessTitle,
            displayExcess,
            priceDetails,
            oneLineDisplay,
            qdsDisplay,
            filterQcpLimits,
          }) => (
            <DisplayCover
              key={coverName}
              coverage={{
                displayName,
                coverName,
                limits,
                excessTitle,
                displayExcess,
              }}
              display={{
                oneLineDisplay,
                qdsDisplay,
                filterQcpLimits,
                withModal,
              }}
              excess={{
                quoteCardExcesses,
                quoteSliderExcesses,
              }}
              displayVariant={displayVariant}
              helpText={helpText}
              priceDetails={priceDetails}
              extraCovers={extraCovers}
            />
          ),
        )}
        {hasOtherStatesCoverage && (
          <IncludedByInsurerCoverage
            coverageTitle="Other States Coverage"
            helpText={helpText}
          />
        )}
        {hasAccidentPolicyCoverage && (
          <IncludedByInsurerCoverage
            coverageTitle="24/7 Medical Expense"
            helpText={helpText}
          />
        )}
        <UpsellContent
          upsells={upsells}
          additionalCoverage={additionalCoverage}
          displayVariant={displayVariant}
        />
      </Flex>
    </Box>
  );
};
